export function escapeBackslashQuery(query: string): string {
  return query.replace(/\\/g, '\\\\');
}

export const queryString = (values: { [key: string]: unknown }) => {
  const cleanValues = Object.fromEntries(
    Object.entries(values).filter(([, v]) => v !== null && v !== undefined)
  );
  const entries: [string, string][] = Object.entries(cleanValues).map(
    ([k, v]) => [k, String(v)]
  );
  const params = new URLSearchParams(entries).toString();

  return params ? `?${params}` : '';
};

const getByPath = <T>(object: Record<string, any>, path: string[] | string) => {
  let next = object;
  const keys = Array.isArray(path) ? path : path.split('.');
  keys.forEach(key => {
    next = next[key];
  });
  return next as T;
};

export const compareObjectKeys = (
  object1: Record<string, any>,
  object2: Record<string, any>,
  keys: string[]
) => keys.every(key => getByPath(object1, key) === getByPath(object2, key));

export const removeMarkdown = (text: string) => {
  return text
    .replace(/```[\s\S]*?```/g, '') // Remove code blocks
    .replace(/`([^`]+)`/g, '$1') // Remove inline code
    .replace(/!\[.*?\]\(.*?\)/g, '') // Remove images
    .replace(/\[([^\]]+)\]\(.*?\)/g, '$1') // Remove links but keep text
    .replace(/(^|\s)([*+-]|\d+\.)\s+/g, '$1') // Remove list markers
    .replace(/(^|\n)>+/g, '$1') // Remove blockquotes
    .replace(/(^|\n)(#+)\s*/g, '$1') // Remove headers
    .replace(/(\*\*|__)(.*?)\1/g, '$2') // Remove bold
    .replace(/(\*(?!\s)|_(?!\s))(.*?)(\1)/g, '$2') // Remove italic but preserve non-formatting asterisks/underscores
    .replace(/~~(.*?)~~/g, '$1') // Remove strikethrough
    .replace(/^\s*[-*_]{3,}\s*$/gm, '') // Remove horizontal rules
    .replace(/\n+/g, ' ') // Replace newlines with a single space
    .replace(/\s+/g, ' ') // Normalize multiple spaces
    .trim(); // Trim spaces
};

export function capitalizeFirstLetter<T extends string>(str: T): Capitalize<T> {
  if (!str) return str as Capitalize<T>;
  return (str.charAt(0).toUpperCase() + str.slice(1)) as Capitalize<T>;
}

export function hash32(s: string) {
  let hash = 0x811c9dc5; // 2166136261, FNV-1a 32-bit offset basis

  for (let i = 0; i < s.length; i++) {
    hash ^= s.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193); // 16777619, FNV prime
    hash >>>= 0; // ensure it's a 32-bit unsigned integer
  }

  return hash.toString(16).padStart(8, '0');
}
